
export const messageTime = 5 * 1000;
export const cookieName = '_token'
